<div class="header-container top-container">
  <h3>Repairer Sites</h3>
  <div class="add-repairer-filter-container">
    <button matButton="elevated" class="charcoal-button" (click)="addRepairerSite()">ADD REPAIRER</button>

    <mat-divider class="header-container-actions-divider" [vertical]="true" />

    <button matIconButton (click)="repairersExpanded = !repairersExpanded">
      <mat-icon>{{ repairersExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </div>
</div>

<mat-divider />

<app-repairer-sites
  [class.hidden]="!repairersExpanded"
  [isToBeRefreshed]="refreshTab"
  [userTimezone]="timezone"
  [repairersGroup]="repairersGroup()" />

<app-multi-location-admin-section class="dashboard-section" />

<app-administrators-section
  class="dashboard-section"
  [sysadminList]="sysadminList()"
  (updateSysadminList)="getSysadmins()" />

<app-quoting-system-section
  class="dashboard-section"
  [quotingSystemList]="quotingSystemList()"
  (updateQuotingSystemList)="getQSystems()"
  (confirmRevokeAllTokens)="confirmRevokeAllTokens($event)"
  (configureInterfaces)="configureInterfaces($event)" />

<app-factoring-companies-section
  class="dashboard-section"
  [factoringCompaniesList]="factoringCompanies()"
  (updateFactoringCompanies)="getFactoringCompanies()" />
